import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faUserTie,
  faUserShield,
  faTimes,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../../function/token";
import domain from "../../../reusecomponent/domain";
import {
  ErrorToastContainer,
  SuccessToastContainer,
} from "../../function/CustomFunction";
import Preloader from "../preloader";
import AddAgentModal from "./AddAgentModal";
import Swal from "sweetalert2";
import "./agents.css";
import AssignChatContactsModal from "./AssignChatContactsModal";

function Agents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingAgent, setEditingAgent] = useState(null);
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [roleLoading, setRoleLoading] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [assignTarget, setAssignTarget] = useState(null);

  useEffect(() => {
    fetchAgents();
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const token = getToken();
      const response = await fetch(`${domain()}/agen_role`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });


      const result = await response.json();
      console.log("Roles API response:", result);

      if (result.status) {
        // Handle different possible response structures
        let rolesData = [];
        if (Array.isArray(result.data)) {
          rolesData = result.data;
        } else if (result.data && Array.isArray(result.data.data)) {
          rolesData = result.data.data;
        } else if (result.data && Array.isArray(result.data.roles)) {
          rolesData = result.data.roles;
        } else if (Array.isArray(result.roles)) {
          rolesData = result.roles;
        } else {
          console.warn("Unexpected roles response structure:", result);
          rolesData = [];
        }

        console.log("Processed roles data:", rolesData);
        setRoles(rolesData);
      } else {
        console.error("Failed to fetch roles:", result.message);
        setRoles([]);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setRoles([]);
    }
  };

  const fetchAgents = async () => {
    setLoading(true);
    try {
      const token = getToken();
      const headers = new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      });

      const response = await fetch(`${domain()}/agents`, {
        method: "GET",
        headers,
      });

      const result = await response.json();

      if (result.status) {
        setAgents(result.data || []);
        // console.log("Agents data : ",agents);
      } else {
        ErrorToastContainer(result.message || "Failed to fetch agents");
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
      ErrorToastContainer("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddAgent = () => {
    // if (!hasPermission(PERMISSIONS.USERS_AGENTS_CREATE)) {
    //   ErrorToastContainer("You don't have permission to create agents");
    //   return;
    // }
    setEditingAgent(null);
    setShowModal(true);
  };

  const handleEditAgent = async (agent) => {
    // if (!hasPermission(PERMISSIONS.USERS_AGENTS_UPDATE)) {
    //   ErrorToastContainer("You don't have permission to update agents");
    //   return;
    // }
    
    try {
      setLoading(true);
      const token = getToken();
      const encodedAgentId = btoa(agent.id); // Base64 encode the agent ID

      const response = await fetch(`${domain()}/agents/${encodedAgentId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status && result.data) {
        // Prepare the agent data for editing
        const agentDataForEdit = {
          ...result.data,
          // Ensure mobile_number is properly set
          mobile_number: result.data.mobile_number || result.data.number || "",
          // Ensure password field exists (but empty for security)
          password: "",
        };

        console.log("Setting editingAgent with:", agentDataForEdit);

        // Set the complete agent data for editing
        setEditingAgent(agentDataForEdit);
        setShowModal(true);
      } else {
        ErrorToastContainer(result.message || "Failed to fetch agent details");
        console.error("Failed to fetch agent details:", result);
      }
    } catch (error) {
      console.error("Error fetching agent details:", error);
      ErrorToastContainer("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const openAssignModal = (agent) => {
    setAssignTarget(agent);
    setAssignModalOpen(true);
  };

  const closeAssignModal = () => {
    setAssignModalOpen(false);
    setAssignTarget(null);
  };

  const handleAssignContacts = async ({ mobile_number, added_type }) => {
    try {
      if (!assignTarget) return;
      const token = getToken();
      const headers = new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      });
      // Assumed backend endpoint for assignment
      const body = JSON.stringify({
        added_type: added_type,
        agent_id: assignTarget.id,
        mobile_number: Array.isArray(mobile_number) ? mobile_number : [],
      });
      const res = await fetch(`${domain()}/assign-chat`, {
        method: "POST",
        headers,
        body,
      });
      const result = await res.json();
      if (result.status) {
        SuccessToastContainer(
          result.message || "Contacts assigned successfully"
        );
        closeAssignModal();
      } else {
        ErrorToastContainer(result.message || "Failed to assign contacts");
      }
    } catch (e) {
      ErrorToastContainer("Network error. Please try again.");
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditingAgent(null);
  };

  const handleAgentSaved = () => {
    fetchAgents();
    handleModalClose();
  };

  const handleDeleteAgent = async (agentId) => {
    // if (!hasPermission(PERMISSIONS.USERS_AGENTS_DELETE)) {
    //   ErrorToastContainer("You don't have permission to delete agents");
    //   return;
    // }
    
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const token = getToken();
        console.log("agent id : ", atob(agentId));

        const response = await fetch(`${domain()}/agents/${agentId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();

        if (result.status) {
          SuccessToastContainer("Agent deleted successfully!");
          fetchAgents();
        } else {
          ErrorToastContainer(result.message || "Failed to delete agent");
        }
      } catch (error) {
        console.error("Error deleting agent:", error);
        ErrorToastContainer("Network error. Please try again.");
      }
    }
  };

  const handleRoleAssignment = async () => {
    if (!selectedRole) {
      ErrorToastContainer("Please select a role");
      return;
    }

    setRoleLoading(true);
    try {
      const token = getToken();
      const response = await fetch(
        `${domain()}/agents/${btoa(selectedAgent.id)}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            role_id: selectedRole,
          }),
        }
      );

      const result = await response.json();

      if (result.status) {
        SuccessToastContainer("Role assigned successfully!");
        setShowRoleModal(false);
        fetchAgents();
      } else {
        ErrorToastContainer(result.message || "Failed to assign role");
      }
    } catch (error) {
      console.error("Error assigning role:", error);
      ErrorToastContainer("Network error. Please try again.");
    } finally {
      setRoleLoading(false);
    }
  };

  const filteredAgents = agents.filter(
    (agent) =>
      agent.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      agent.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      agent.mobile_number?.includes(searchTerm) ||
      agent.number?.includes(searchTerm)
  );

  if (loading) {
    return <Preloader action={true} />;
  }

  // Check if user has permission to view agents
  // if (!hasPermission(PERMISSIONS.USERS_AGENTS_VIEW)) {
  //   return (
  //     <div className="agents-container">
  //       <div className="permission-denied">
  //         <h3>Access Denied</h3>
  //         <p>You don't have permission to view agents.</p>
  //         {/* <p>Debug: Role = {userRole}, IsOwner = {isOwner ? 'Yes' : 'No'}</p>
  //         <p>Debug: All permissions = {JSON.stringify(getAllPermissions())}</p> */}
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="agents-container">
      <div className="agents-header">
        <div className="agents-title-section">
          <h1 className="agents-title">
            <FontAwesomeIcon icon={faUserTie} className="agents-title-icon" />
            Manage Agents
          </h1>
          <p className="agents-subtitle">
            Create, edit, and manage your team agents
          </p>
        </div>
        {/* <PermissionGuard permission={PERMISSIONS.USERS_AGENTS_CREATE}>
          <button
            className="btn btn-primary agents-add-btn"
            onClick={handleAddAgent}
          >
            <FontAwesomeIcon icon={faPlus} className="agents-add-icon" />
            <span className="agents-add-text">Add New Agent</span>
          </button>
        </PermissionGuard> */}
      </div>

      {/* Search Bar */}
      <div className="agents-search-section">
        <div className="search-container">
          <div className="search-icon-wrapper"></div>
          <input
            type="text"
            className="search-input"
            placeholder="Search agents by name, email, or number..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <Preloader action={loading} />

      {!loading && (
        <div className="agents-content">
          {filteredAgents.length > 0 ? (
            <div className="agents-table-container">
              {/* Desktop Table View */}
              <div className="agents-table-desktop">
                <table className="agents-table">
                  <thead>
                    <tr>
                      <th className="table-header">Profile</th>
                      <th className="table-header">Name</th>
                      <th className="table-header">Email</th>
                      <th className="table-header">Phone</th>
                      <th className="table-header">Status</th>
                      <th className="table-header">Role</th>
                      <th className="table-header">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAgents.map((agent) => (
                      <tr key={agent.id} className="table-row">
                        <td className="profile-cell">
                          <div className="profile-wrapper">
                            <img
                              src={
                                agent.profile_picture
                                  ? `https://api.campaigningtool.com/agent/${agent.profile_picture}`
                                  : "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                              }
                              alt={agent.name}
                              className="profile-image"
                              onError={(e) => {
                                e.target.src =
                                  "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png";
                              }}
                            />
                          </div>
                        </td>
                        <td className="name-cell">
                          <span className="agent-name">{agent.name}</span>
                        </td>
                        <td className="email-cell">
                          <span className="agent-email">{agent.email}</span>
                        </td>
                        <td className="phone-cell">
                          <span className="agent-phone">
                            {agent.mobile_number}
                          </span>
                        </td>
                        <td className="status-cell">
                          <span
                            className="status-text"
                            style={{
                              color:
                                agent.isactive === "1" || agent.isactive === 1
                                  ? "#075E54"
                                  : "#6c757d",
                              fontWeight:
                                agent.isactive === "1" || agent.isactive === 1
                                  ? "600"
                                  : "500",
                            }}
                          >
                            {agent.isactive === "1" || agent.isactive === 1
                              ? "ACTIVE"
                              : "INACTIVE"}
                          </span>
                        </td>
                        <td className="role-cell">
                          {agent.role_name ? (
                            <span className="role-badge role-assigned">
                              {agent.role_name}
                            </span>
                          ) : (
                            <span className="role-badge role-unassigned">
                              No Role
                            </span>
                          )}
                        </td>
                        <td className="actions-cell">
                          <div className="actions-wrapper">
                            {/* <PermissionGuard permission={PERMISSIONS.USERS_AGENTS_UPDATE}>
                              <button
                                className="action-btn action-edit"
                                onClick={() => handleEditAgent(agent)}
                                title="Edit Agent"
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </button>
                            </PermissionGuard>

                            <PermissionGuard permission={PERMISSIONS.USERS_AGENTS_DELETE}>
                              <button
                                className="action-btn action-delete"
                                onClick={() => handleDeleteAgent(btoa(agent.id))}
                                title="Delete Agent"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </PermissionGuard> */}
{/* 
                            {((userRole === "Owner") || (userRole === "Agent" && hasPermission(PERMISSIONS.WHATSAPP_CHATS_CHAT_ASSIGN_ENABLE))) && agent.role_name && (
                              <button
                                className="action-btn"
                                style={{
                                  backgroundColor: "#0d6efd",
                                  color: "#fff",
                                }}
                                onClick={() => openAssignModal(agent)}
                                title="Assign Chat Contact"
                              >
                                <FontAwesomeIcon icon={faUserCheck} />
                              </button>
                            )} */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card View */}
              <div className="agents-table-mobile">
                {filteredAgents.map((agent) => (
                  <div key={agent.id} className="agent-card">
                    <div className="agent-card-header">
                      <div className="agent-profile-section">
                        <img
                          src={
                            agent.profile_picture
                              ? `https://api.campaigningtool.com/agent/${agent.profile_picture}`
                              : "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                          }
                          alt={agent.name}
                          className="agent-card-profile"
                          onError={(e) => {
                            e.target.src =
                              "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png";
                          }}
                        />
                        <div className="agent-info">
                          <h3 className="agent-card-name">{agent.name}</h3>
                          <span
                            className="status-text"
                            style={{
                              color:
                                agent.isactive === "1" || agent.isactive === 1
                                  ? "#075E54"
                                  : "#6c757d",
                              fontWeight:
                                agent.isactive === "1" || agent.isactive === 1
                                  ? "600"
                                  : "500",
                            }}
                          >
                            {agent.isactive === "1" || agent.isactive === 1
                              ? "ACTIVE"
                              : "INACTIVE"}
                          </span>
                        </div>
                      </div>
                      <div className="agent-card-actions">
                        {/* {hasPermission(PERMISSIONS.USERS_AGENTS_UPDATE) && (
                          <button
                            className="mobile-action-btn mobile-edit-btn"
                            onClick={() => handleEditAgent(agent)}
                            title="Edit Agent"
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        )}
                        {hasPermission(PERMISSIONS.USERS_AGENTS_DELETE) && (
                          <button
                            className="mobile-action-btn mobile-delete-btn"
                            onClick={() => handleDeleteAgent(btoa(agent.id))}
                            title="Delete Agent"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        )}
                        {((userRole === "Owner") || (userRole === "Agent" && hasPermission(PERMISSIONS.WHATSAPP_CHATS_CHAT_ASSIGN_ENABLE))) && agent.role_name && (
                          <button
                            className="mobile-action-btn"
                            style={{
                              backgroundColor: "#0d6efd",
                              color: "#fff",
                            }}
                            onClick={() => openAssignModal(agent)}
                            title="Assign Chat Contact"
                          >
                            <FontAwesomeIcon icon={faUserCheck} />
                          </button>
                        )} */}
                      </div>
                    </div>

                    <div className="agent-card-body">
                      <div className="agent-detail-row">
                        <span className="detail-label">Email:</span>
                        <span className="detail-value">{agent.email}</span>
                      </div>
                      <div className="agent-detail-row">
                        <span className="detail-label">Phone:</span>
                        <span className="detail-value">
                          {agent.mobile_number}
                        </span>
                      </div>
                      <div className="agent-detail-row">
                        <span className="detail-label">Role:</span>
                        {agent.role_name ? (
                          <span className="role-badge role-assigned">
                            {agent.role_name}
                          </span>
                        ) : (
                          <span className="role-badge role-unassigned">
                            No Role
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="agents-empty-state">
              <div className="empty-state-icon">
                <FontAwesomeIcon icon={faUserTie} />
              </div>
              <h2 className="empty-state-title">No agents found</h2>
              <p className="empty-state-description">
                {searchTerm
                  ? "Try adjusting your search terms."
                  : "Get started by adding your first agent."}
              </p>
              {/* {!searchTerm && hasPermission(PERMISSIONS.USERS_AGENTS_CREATE) && (
                <button
                  className="btn btn-primary empty-state-btn"
                  onClick={handleAddAgent}
                >
                  <FontAwesomeIcon
                    icon={faPlus}
                    className="empty-state-btn-icon"
                  />
                  Add First Agent
                </button>
              )} */}
            </div>
          )}
        </div>
      )}

      {/* Add/Edit Agent Modal */}
      <AddAgentModal
        showModal={showModal}
        onClose={handleModalClose}
        onAgentSaved={handleAgentSaved}
        editingAgent={editingAgent}
      />

      {/* Grant Role Modal */}
      {showRoleModal && (
        <div className="role-modal-overlay">
          <div className="role-modal">
            <div className="role-modal-header">
              <h3 className="role-modal-title">
                <FontAwesomeIcon
                  icon={faUserShield}
                  className="role-modal-icon"
                />
                Grant Role to Agent
              </h3>
              <button
                type="button"
                className="role-modal-close"
                onClick={() => setShowRoleModal(false)}
                disabled={roleLoading}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="role-modal-body">
              {selectedAgent && (
                <div className="selected-agent-info">
                  <div className="selected-agent-profile">
                    <img
                      src={
                        selectedAgent.profile_picture
                          ? `https://api.campaigningtool.com/agent/${selectedAgent.profile_picture}`
                          : "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                      }
                      alt={selectedAgent.name}
                      className="selected-agent-image"
                      onError={(e) => {
                        e.target.src =
                          "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png";
                      }}
                    />
                    <div className="selected-agent-details">
                      <h4 className="selected-agent-name">
                        {selectedAgent.name}
                      </h4>
                      <span className="selected-agent-email">
                        {selectedAgent.email}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className="role-select-section">
                <label htmlFor="roleSelect" className="role-select-label">
                  Select Role <span className="required">*</span>
                </label>
                <select
                  className="role-select-input agent-select"
                  id="roleSelect"
                  value={selectedRole}
                  onChange={(e) => setSelectedRole(e.target.value)}
                  disabled={roleLoading}
                >
                  <option value="">Choose a role...</option>
                  {Array.isArray(roles) &&
                    roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.role_name}
                      </option>
                    ))}
                </select>
              </div>

              {(!Array.isArray(roles) || roles.length === 0) && (
                <div className="role-warning">
                  <FontAwesomeIcon
                    icon={faUserShield}
                    className="role-warning-icon"
                  />
                  No roles available. Please create roles first in the User
                  Roles section.
                </div>
              )}
            </div>

            <div className="role-modal-footer">
              <button
                type="button"
                className="btn btn-secondary role-modal-cancel"
                onClick={() => setShowRoleModal(false)}
                disabled={roleLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary role-modal-assign"
                onClick={handleRoleAssignment}
                disabled={roleLoading || !selectedRole}
              >
                {roleLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Assigning...
                  </>
                ) : (
                  "Assign Role"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <AssignChatContactsModal
        isOpen={assignModalOpen}
        onClose={closeAssignModal}
        onAssign={handleAssignContacts}
        agentId={assignTarget?.id}
      />
    </div>
  );
}

export default Agents;
